import { CSSProperties } from 'react'
import Styles from './VisualStylePreview.module.scss'
import cx from 'classnames'

export type TextOverlayVariant = 'bottom-left' | 'top-full-bg' | 'bottom-right-box'

export interface TextOverlayProps {
  fontStyle: CSSProperties
  variant: TextOverlayVariant
  textColor?: string
}

export const TextOverlay = ({ fontStyle, variant, textColor }: TextOverlayProps) => {
  const variantClassName = {
    'bottom-left': Styles.textOverlayBottomLeft,
    'top-full-bg': Styles.textOverlayTopFullBg,
    'bottom-right-box': Styles.textOverlayBottomRightBox,
  }[variant]

  return (
    <div className={cx(Styles.textOverlay, variantClassName)} style={fontStyle}>
      <span style={{ padding: '6px 12px 6px 12px', backgroundColor: textColor, borderRadius: '12px 12px 12px 0' }}>
        How to Master A Stand
      </span>
      <br />
      <span style={{ padding: '0 12px 6px 12px', backgroundColor: textColor, borderRadius: '0 0 12px 12px' }}>
        Out Brand
      </span>
    </div>
  )
}
